import React, { useState } from "react";
import { api } from "../../../../lib/api";
import { Button } from "../../../../components/ui/button";
import { Label } from "../../../../components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../../../../components/ui/dialog";
import { toast } from "sonner";

export function ChangePasswordButton() {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("New passwords don't match");
      return;
    }
    if (next.length < 8) {
      toast.error("New password must be at least 8 characters");
      return;
    }
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", {
        current_password: current,
        new_password: next,
      });
      if (r.data?.token) {
        if (sessionStorage.getItem("cr_token")) sessionStorage.setItem("cr_token", r.data.token);
        else localStorage.setItem("cr_token", r.data.token);
      }
      toast.success("Password updated. You're still signed in with a fresh token.");
      setOpen(false);
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not change password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="text-xs px-3 py-1.5 rounded-lg border border-[#184A30]/30 text-[#184A30] hover:bg-[#184A30]/5"
          data-testid="change-password-btn"
        >
          Change password
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-md bg-[#FBF9F6] border-[#E5E0D8]" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="serif text-3xl">Change your password</DialogTitle>
          <DialogDescription className="text-[#4A5C50]">
            Updates only your account. Other admins / users stay signed in.
            For a global sign-out, use "Sign out all sessions".
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 py-2">
          <div>
            <Label className="text-xs tracking-widest uppercase text-[#4A5C50]">Current password</Label>
            <input
              type="password" autoComplete="current-password"
              className="underline-input mono"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              data-testid="cp-current"
              required
            />
          </div>
          <div>
            <Label className="text-xs tracking-widest uppercase text-[#4A5C50]">New password</Label>
            <input
              type="password" autoComplete="new-password"
              className="underline-input mono"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              data-testid="cp-new"
              minLength={8}
              required
            />
          </div>
          <div>
            <Label className="text-xs tracking-widest uppercase text-[#4A5C50]">Confirm new password</Label>
            <input
              type="password" autoComplete="new-password"
              className="underline-input mono"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              data-testid="cp-confirm"
              minLength={8}
              required
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={() => setOpen(false)} data-testid="cp-cancel">Cancel</Button>
            <Button
              type="submit"
              disabled={busy}
              className="rounded-xl bg-[#184A30] hover:bg-[#0F3320] text-white disabled:opacity-50"
              data-testid="cp-submit"
            >
              {busy ? "Updating…" : "Update password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
